var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap"},[_c('JobList'),_c('transition',{attrs:{"name":"main","mode":"out-in"}},[_c('keep-alive',[_c('router-view',{nativeOn:{"scroll":function($event){$event.stopPropagation();return (()=>{}).apply(null, arguments)}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }